import { Box, Button, CircularProgress, Paper, Stack, styled, Typography } from '@mui/material';
import SuccessImg from 'assets/success_img.png';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import SubmissionService from 'services/SubmissionService';

export interface ErrorResponseType {
  message: string;
  error_code: string;
  errors?: ErrorType[];
}

export interface ErrorType {
  path: string;
  message: string;
}

const ReconfirmationRejectPage = () => {
  const { submissionId } = useParams();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const email = searchParams.get('email') || '';

  useEffect(() => {
    (async () => {
      if (submissionId) {
        setIsLoading(true);
        SubmissionService.reconfirmationReject(submissionId, email)
          .then(() => {
            setIsSuccess(true);
          })
          .catch((error) => {
            if (error.response?.data.error_code === 'SUBMISSION_REVIEW_COMPLETED') {
              return setIsError(false);
            }

            if (error.response?.data.error_code === 'SUBMISSION_UPDATE_NOT_ALLOWED') {
              return setIsError(false);
            }

            return setIsError(true);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    })();
  }, [email, submissionId]);

  const goToBSS = () => {
    // navigate to BSS Website
    window.location.href = 'https://www.banksampoerna.com';
  };

  const onPageReload = () => {
    // reload page
    window.location.reload();
  };

  return (
    <PaperStyled>
      {isLoading ? (
        <BoxLoadingSpinner>
          <CircularProgress />
          <Typography color="surface.700" fontWeight="500" variant="h7">
            Mohon menunggu, permintaan sedang di proses...
          </Typography>
        </BoxLoadingSpinner>
      ) : isError ? (
        <BoxLoadingSpinner>
          <Typography color="surface.700" fontWeight="500" variant="h7">
            Sistem mengalami kendala, mohon coba kembali beberapa saat lagi
          </Typography>
          <Button variant="contained" sx={{ maxWidth: 200 }} onClick={onPageReload}>
            Coba Kembali
          </Button>
        </BoxLoadingSpinner>
      ) : (
        <StackStyled spacing={2}>
          <img alt="success-img" src={SuccessImg} height="160" width="160" />
          <Typography color="surface.700" variant="h4">
            {isSuccess ? 'Selesai' : 'Aplikasi Tidak Dikonfirmasi'}
          </Typography>
          <Button variant="contained" sx={{ maxWidth: 200 }} onClick={goToBSS}>
            Kembali ke Beranda
          </Button>
        </StackStyled>
      )}
    </PaperStyled>
  );
};

const PaperStyled = styled(Paper)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3)
}));

const StackStyled = styled(Stack)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

const BoxLoadingSpinner = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 300,
  gap: theme.spacing(5)
}));

export default ReconfirmationRejectPage;
